export default __webpack_public_path__ + "static/typography-image-i-fa2d3fc3c4a5c6e4df5573894197490f.png";